import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { gluteForYou, gluteNotForYou } from '../../data/gluteCopy';
export function GluteAudience() {
  return <section aria-labelledby="glute-para-quien" className="w-full bg-coal" data-id="element-78" data-mp="3mav1cndkwkup">
      <div className="mx-auto w-full max-w-5xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-79" data-mp="3r6tjht8bd6mo">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-80" data-mp="3vb9pduhxge1w">
          Para quién es
        </p>
        <h2 id="glute-para-quien" className="mt-5 text-[1.75rem] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-81" data-mp="41krt6qxpyb1">
          ¿Es esto para ti?
        </h2>

        <div className="mt-10 grid gap-10 md:grid-cols-2 md:gap-16" data-id="element-82" data-mp="isbgw7156jag">
          <div data-id="element-83" data-mp="iric3blqu3uy">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white" data-id="element-84" data-mp="iu4eyxxovv6u">
              Sí, si eres de las que…
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-85" data-mp="rs7yjop46hw0">
              {gluteForYou.map(item => <li key={item} className="flex gap-3 text-[0.95rem] leading-relaxed text-white/60 sm:text-base" data-id="element-86" data-mp="1snwykqg4gjh4">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-ember" strokeWidth={3} aria-hidden="true" data-id="element-87" data-mp="1oo68yq2c09e6" />
                  <span data-id="element-88" data-mp="1epqkkuuove8d">{item}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-89" data-mp="2cd7cbywb4ucl">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white/45" data-id="element-90" data-mp="27cjlpebzqfiw">
              No, si buscas…
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-91" data-mp="22kjhh9ow10gi">
              {gluteNotForYou.map(item => <li key={item} className="flex gap-3 text-[0.95rem] leading-relaxed text-white/35 sm:text-base" data-id="element-92" data-mp="1xlglsfuss6l7">
                  <MinusIcon className="mt-1 h-4 w-4 shrink-0 text-white/25" strokeWidth={3} aria-hidden="true" data-id="element-93" data-mp="2qb5l8oruzykp" />
                  <span data-id="element-94" data-mp="sf78uxx9suc7">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}